const n = "Bezig met laden...", a = {
  loading: n
};
export {
  a as default,
  n as loading
};
